import HomeRoute from "../../components/routes/HomeRoute";
import messages from "../../i18n/messages/de.json";

export default function Page() {
  return <HomeRoute locale="de" messages={messages} />;
}
